import { crmApiInstance } from './client.js';

export const productsApi = {
  getAll:        (params = {}) => crmApiInstance.get('/products', { params }).then(r => r.data),
  getById:       (id)          => crmApiInstance.get(`/products/${id}`).then(r => r.data),
  create:        (payload)     => crmApiInstance.post('/products', payload).then(r => r.data),
  update:        (id, payload) => crmApiInstance.put(`/products/${id}`, payload).then(r => r.data),
  remove:        (id)          => crmApiInstance.delete(`/products/${id}`).then(r => r.data),
  updatePrice:   (id, payload) => crmApiInstance.put(`/products/${id}/price`, payload).then(r => r.data),
  getPriceHistory:  (id)          => crmApiInstance.get(`/products/${id}/price-history`).then(r => r.data),
  downloadTemplate: ()            => crmApiInstance.get('/products/template', { responseType: 'blob' }),
  importProducts:   (text)        => crmApiInstance.post('/products/import', text, { headers: { 'Content-Type': 'text/csv' } }).then(r => r.data),
  exportProducts:   (params = {}) => crmApiInstance.get('/products/export', { params, responseType: 'arraybuffer' }),
  getCategories:    ()            => crmApiInstance.get('/products/categories').then(r => r.data),
  createCategory:   (payload)     => crmApiInstance.post('/products/categories', payload).then(r => r.data),
  updateCategory:   (id, payload) => crmApiInstance.put(`/products/categories/${id}`, payload).then(r => r.data),
};
